import { navigate } from '@reach/router'

type GoToPrintMapT = (params: { apId: string; floorId: string }) => Promise<void>

const goToPrintMap: GoToPrintMapT = ({ apId, floorId }) =>
  navigate(`${basePath}/${apId}/${floorId}`)

const basePath = '/print_map'
export const printMapPath = `${basePath}/:apId/:floorId`

export default goToPrintMap
